import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';

export const sessionApi = createApi({
	reducerPath: 'sessionApi',
	tagTypes: ['sessions'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getEventSessionsById: builder.query({
			query: ({ id, filters }: { id: string; filters: any }) => ({
				url: `events/${id}/sessions`,
				params: { ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['sessions'],
		}),
		getSessions: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `sessions`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['sessions'],
		}),
		deleteSession: builder.mutation({
			query: (id: UUID) => ({
				url: `sessions/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['sessions'],
		}),
		addSession: builder.mutation({
			query: ({ eventId, name, description }: { description: string; name: string; eventId: UUID }) => ({
				url: `sessions`,
				method: 'POST',
				body: { eventId, name, description },
			}),
			invalidatesTags: ['sessions'],
		}),
		updateSession: builder.mutation({
			query: ({
				eventId,
				name,
				id,
				description,
			}: {
				description: string;
				name: string;
				eventId: UUID;
				id: UUID;
			}) => ({
				url: `sessions/${id}`,
				method: 'PATCH',
				body: { eventId, name, description },
			}),
			invalidatesTags: ['sessions'],
		}),
		uploadImage: builder.mutation({
			query: ({ id, body }) => ({
				url: `sessions/${id}/image`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['sessions'],
		}),
	}),
});

export const {
	useGetEventSessionsByIdQuery,
	useAddSessionMutation,
	useDeleteSessionMutation,
	useGetSessionsQuery,
	useUpdateSessionMutation,
	useUploadImageMutation,
} = sessionApi;
